import {useSelector} from 'react-redux';

export default function useLoadNotification() {
  const notification = useSelector((state: any) => state.NotificationReducer);
  return notification.onlyNotification;
}
